<style lang="less" scoped>
  @import './base.less';

  .more {
    position: relative;
    .mask {
      background: rgba(0, 0, 0, .2);
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 90;
    }
    .items{
      position: absolute;
      width: 6.6rem;
      top: 1.5rem;
      right: -0.25rem;
      background-color: white;
      z-index: 100;
      transform-origin: 100% 0;
      &:before{
        content: "";
        position: absolute;
        border-top: .3rem solid white;
        border-left: .3rem solid transparent;
        right: 10px;
        top: -0.15rem;
        transform: rotate(-45deg);
      }
      ul{
        padding: 0 .6rem;
        li{
          height: 2.2rem;
          display: flex;
          align-items: center;
          justify-content: space-around;
          position: relative;
          &:active{
            opacity: 0.9;
          }
          i{
            width: .65rem;
            height: .75rem;
            display: block;
            margin-right: .45rem;
          }
          span{
            flex: 1;
          }
          .home{
            background: url("./img/home.png")no-repeat;
            background-size: 100%;
          }
          .qa {
            background: url("./img/qa.png")no-repeat;
            background-size: 100%;
          }
          .info{
            background: url("./img/info.png")no-repeat;
            background-size: 100%;
          }
          .login{
            background: url("./img/login.png")no-repeat;
            background-size: 100%;
          }
          .logout{
            background: url("./img/logout.png")no-repeat;
            background-size: 100%;
          }
        }
        .line{
          &:after{
            .bottom-px1(@lineColor);
          }
        }
      }
    }
    i {
      width: @icon;
      height: @icon;
      display: block;
      background: url("./img/more.png") no-repeat;
      background-size: 100%;
      vertical-align: middle;
      z-index: 101;
      &:active {

      }
    }
    i.light{
      background: url("./img/more_light.png") no-repeat;
      background-size: 100%;
    }
  }
  .slide-fade-enter-active {
    transition: all .1s ease-out;
  }
  .slide-fade-leave-active {
    transition: all .2s ease-out;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: scale(.9, .7);
    opacity: 0;
  }

</style>
<template>
  <div class="more">
    <i @click="toggle" :class="setStyle"></i>
    <transition name="slide-fade" mode="out-in" appear>
      <div class="items" v-show="show">
        <ul>
          <li @click="goHome" class="line" v-if="info.home"><i class="home"></i> <span v-text="info.home"></span></li>
          <li @click="goQa" class="line"><i class="qa"></i> <span v-text="info.qa.title"></span></li>
          <li @click="goAbout" class="line" v-if="info.about.title"><i class="info"></i> <span v-text="info.about.title"></span></li>
          <li @click="goChangePhone" class="line" v-if="info.changePhone"><i class="info"></i> <span v-text="info.changePhone.title"></span></li>
          <li @click="goChangeBankCard" class="line" v-if="info.changeBankCard"><i class="info"></i> <span v-text="info.changeBankCard.title"></span></li>
          <li @click="goLoanDetail(info.loanDetail)" class="line" v-if="info.loanDetail"><i class="info"></i> <span v-text="info.loanDetail.title"></span></li>
          <div v-if="showLoginSlide">
            <li @click="logout" v-if="loginState"><i class="logout"></i> <span>退出</span></li>
            <li @click="login" v-else><i class="login"></i> <span>登录</span></li>
          </div>
        </ul>
      </div>
    </transition>

    <transition name="fade" mode="out-in" appear>
      <div v-bind:style="maskStyle" @click="hide" v-show="show" class="mask"></div>
    </transition>
  </div>
</template>
<script>
  import formatPath from 'bjxy-common/helper/formatPath'
  import config from  './config'
  import api from './api'
  import {mapState,mapGetters} from 'vuex'
  import getQueryString from 'bjxy-common/helper/getQueryString'
  import addUrlQuery from 'bjxy-common/helper/addUrlQuery'
  import { extend } from 'bjxy-common/helper/utils'
  import replaceDomain from 'bjxy-common/xyHelper/replaceDomain'
  export default {
    data() {
      return {
        show:false,
        config:config,
        source:getQueryString('source')
      }
    },
    name: 'more',
    props:{
      maskStyle: {
        type: Object,
        default: function () {
          return { top: 0 }
        }
      },
      productType:{
        type: Number,
        default: function() {
          return 0
        }
      },
      setStyle:String,
      showLoginSlide: {
        type:Boolean,
        default: true
      },
      propConfig: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    computed: {
      ...mapState(['loginState']),
      info(){
        return extend(this.config[this.productType],this.propConfig)
      }
    },
    methods: {
      toggle(){
        this.show = !this.show;
      },
      hide(){
        this.show = false
      },
      goHome(){
        this.$router.push({name:'home'})
        this.hide()
      },
      open(key){
        var obj = this.info[key].url;
        var src = obj.src;
        src = encodeURIComponent(formatPath(src));
        let ifShowNavigation = this.productType=== 0;
        this.$router.push({name: 'iframe',params:{_pass:true}, query: {title: obj.title,src:src,ifShowNavigation: ifShowNavigation}})
        this.hide()
      },
      goQa(){
        this.open('qa')
        this.hide()
      },
      goAbout(){
        this.open('about')
        this.hide()
      },
      goChangeBankCard(){
        this.hide()
        let src = this.info['changeBankCard'].url.src
        if(this.source){
          src = addUrlQuery(src,{source:this.source})
        }
        return location.href = replaceDomain(src)
      },
      goChangePhone(){
        this.hide()
        let src = this.info['changePhone'].url.src
        if(this.source){
          src = addUrlQuery(src,{source:this.source})
        }
        return location.href = replaceDomain(src)
      },
      goLoanDetail(obj){
        this.hide()
        if (/^http(s)?:\/\//.test(obj.url)) {
          location.href = replaceDomain(obj.url)
        }else {
          this.$router.push({name: obj.url, params:{_pass:true}});
        }
      },
      login(){
        this.$router.push({name:'login',params:{_pass:true}});
        this.hide();
      },
      logout(){
        this.post(api.logout).then(()=>{
          this.$router.push({name:'login',params:{_pass:true}})
          this.commit('loginState',{loginState:false});
        },json=>{
          this.toast(json.errstr)
        })
        this.hide()
      }
    }
  }
</script>
